import { Sparkles } from "lucide-react";
import { useCommercialMode } from "@/hooks/useCommercialMode";

/**
 * Bannière promo affichée en haut des pages tarif quand le mode gratuit
 * est activé par l'admin.
 */
const FreeModeBanner = ({ className = "" }: { className?: string }) => {
  const { freeMode, badgeText } = useCommercialMode();
  if (!freeMode) return null;

  return (
    <div
      className={`rounded-2xl bg-gradient-to-r from-emerald-500 via-emerald-400 to-teal-500 p-5 text-white text-center shadow-lg ${className}`}
    >
      <div className="flex items-center justify-center gap-2 mb-1">
        <Sparkles className="w-5 h-5" />
        <span className="font-bold text-lg">{badgeText}</span>
        <Sparkles className="w-5 h-5" />
      </div>
      <p className="text-sm opacity-95">
        Toutes les fonctionnalités Premium sont accessibles sans abonnement.
      </p>
    </div>
  );
};

export default FreeModeBanner;
